import {BrowserModule} from '@angular/platform-browser';
import {NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import {LocationStrategy, HashLocationStrategy} from '@angular/common';
import {HttpModule, Http, BrowserXhr} from '@angular/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {AppComponent} from './app.component';
import {AppRoutingModule} from './app.routing' ;
import {EqualValidator} from './equal-validator.directive';
import {NgbActiveModal, NgbModule} from '@ng-bootstrap/ng-bootstrap';

import {InputTextModule} from 'primeng/inputtext';
import {ButtonModule} from 'primeng/button';
import {TableModule} from 'primeng/table';
import {DialogModule} from 'primeng/dialog';
import {ConfirmDialogModule} from 'primeng/components/confirmdialog/confirmdialog';
import {ConfirmationService} from 'primeng/components/common/api';
import {Message} from 'primeng/components/common/api';
import {MessageService} from 'primeng/components/common/messageservice';

import {MessagesModule, MultiSelectModule} from 'primeng/primeng';
import {MessageModule} from 'primeng/message';
import {GrowlModule} from 'primeng/growl';

import {MockBackend, MockConnection} from '@angular/http/testing';
import {BaseRequestOptions} from '@angular/http';

import {DropdownModule} from 'ngx-dropdown';
import {NgProgressModule, NgProgressBrowserXhr} from 'ngx-progressbar';

import {customHttpProvider} from './helpers/index';
import {AlertComponent} from './directives/alert/alert.component';
import {AuthGuard} from './guards/index';
import {AlertService, AuthenticationService, UserService, LogService} from './services/index';

import {
    FullLayoutComponent,
    SimpleLayoutComponent,
    TabLayoutComponent
} from './containers';

const APP_CONTAINERS = [
    FullLayoutComponent,
    SimpleLayoutComponent,
    TabLayoutComponent
]

// Import components
import {
    AppAsideComponent,
    AppBreadcrumbsComponent,
    AppFooterComponent,
    AppHeaderComponent,
    AppSidebarComponent,
    AppSidebarFooterComponent,
    AppSidebarFormComponent,
    AppSidebarHeaderComponent,
    AppSidebarMinimizerComponent,
  ItemBranchesComponent,
    ListLayoutComponent,
    APP_SIDEBAR_NAV
} from './components';

const APP_COMPONENTS = [
    AppAsideComponent,
    AppBreadcrumbsComponent,
    AppFooterComponent,
    AppHeaderComponent,
    AppSidebarComponent,
    AppSidebarFooterComponent,
    AppSidebarFormComponent,
    AppSidebarHeaderComponent,
    AppSidebarMinimizerComponent,
  ItemBranchesComponent,
    ListLayoutComponent,
    APP_SIDEBAR_NAV
]

// Import directives
import {
    AsideToggleDirective,
    NAV_DROPDOWN_DIRECTIVES,
    ReplaceDirective,
    SIDEBAR_TOGGLE_DIRECTIVES,
    OnlyNumberDirective
} from './directives';

const APP_DIRECTIVES = [
    AsideToggleDirective,
    NAV_DROPDOWN_DIRECTIVES,
    ReplaceDirective,
    SIDEBAR_TOGGLE_DIRECTIVES,
    OnlyNumberDirective
]

// Import 3rd party components
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import {TabsModule} from 'ngx-bootstrap/tabs';
import {ChartsModule} from 'ng2-charts/ng2-charts';
import {AppLogComponent} from './components/app-log/app-log.component';
import {AppTasksComponent} from './components/app-tasks/app-tasks.component';
import {AppArcComponent} from './components/app-arc/app-arc.component';
import { AppPdfComponent } from './components/app-pdf';
// import { AppUserComponent } from './components/app-user/app-user.component';
import {UserProfileComponent} from './components/user-profile/user-profile.component';
import {UserSettingsComponent} from './components/user-settings/user-settings.component';
import {UserPictureComponent} from './components/user-picture/user-picture.component';
import {PopoverModule} from 'ngx-popover';
import {NgxPaginationModule} from "ngx-pagination";
import {ItemService} from "./services/item.service";
import {BranchesShowComponent} from "./views/setting/branches/branches-show/branches-show.component";
import {DepartmentsShowComponent} from "./views/setting/departments/departments-show/departments-show.component";
import {ProcessesShowComponent} from "./views/management/processes/processes-show/processes-show.component";
import {ClassificationsShowComponent} from "./views/setting/classifications/classifications-show/classifications-show.component";
import {ArchiveShowComponent} from "./views/setting/archive/archive-show/archive-show.component";
import {BranchesSettingsShowComponent} from "./views/setting/branches_settings/branches_settings-show/branches_settings-show.component";
import {MembersShowComponent} from "./views/setting/members/members-show/members-show.component";
import {CitiesShowComponent} from "./views/setting/cities/cities-show/cities-show.component";

import {CurrenciesShowComponent} from "./views/setting/currencies/currencies-show/currencies-show.component";
import {CustomersShowComponent} from "./views/setting/customers/customers-show/customers-show.component";
import {ItemsShowComponent} from "./views/setting/items/items-show/items-show.component";
import {OrganizationShowComponent} from "./views/setting/organization/organization-show/organization-show.component";
import {ItemsGroupsShowComponent} from "./views/setting/itemsGroups/itemsGroups-show/itemsGroups-show.component";
import {TaxesShowComponent} from "./views/setting/taxes/taxes-show/taxes-show.component";
import {YearsShowComponent} from "./views/setting/years/years-show/years-show.component";
import {JobsShowComponent} from "./views/setting/jobs/jobs-show/jobs-show.component";
import {UsersShowComponent} from "./views/setting/users/users-show/users-show.component";
import {RecordDataComponent} from "./components/record-data/record-data.component";
import {BranchesListComponent} from "./components/branches-list/branches-list.component";
import {DepartmentsListComponent} from './components';
import {YearsListComponent} from "./components/years-list/years-list.component";
import {StoresShowComponent} from "./views/setting/stores/stores-show/stores-show.component";
import { AppDateComponent } from './components/app-date/app-date.component';
import { NumbersComponent } from './components/app-numbers/app-numbers.component';
import {SaveTemplateComponent} from "./components/save-template/save-template.component";
import { ImageViewerModule } from 'ng2-image-viewer';
import {ParentShowComponent} from "./components/parent-show/parent-show.component";
import { PermissionsShowComponent } from "./views/setting/permissions/permissions-show/permissions-show.component"
import {EmployeesShowComponent} from "./views/setting/employees/employees-show/employees-show.component";
import { InvoicesShowComponent } from "./views/pos/invoices/invoices-show/invoices-show.component";
import { ItemlistsShowComponent } from "./views/pos/itemlists/itemlists-show/itemlists-show.component";
import {BanksShowComponent} from "./views/setting/banks/banks-show/banks-show.component";
import {AccountsShowComponent} from "./views/fin/accounts/accounts-show/accounts-show.component";
import {RecieptVouchersShowComponent} from "./views/fin/reciept_vouchers/reciept_vouchers-show/reciept_vouchers-show.component";
import {ExpenseVouchersShowComponent} from "./views/fin/expense_vouchers/expense_vouchers-show/expense_vouchers-show.component";
import {JournalsShowComponent} from "./views/fin/journals/journals-show/journals-show.component";
import {AdditionalsShowComponent} from "./views/fin/additionals/additionals-show/additionals-show.component";
import { CurrencyMaskModule } from "ng2-currency-mask";
import { CurrencyMaskConfig, CURRENCY_MASK_CONFIG } from "ng2-currency-mask/src/currency-mask.config";
import {Account_reportListComponent} from "./views/fin/account_report/account_report-list/account_report-list.component";
import {OpeningbalancesShowComponent} from "./views/fin/openingbalances/openingbalances-show/openingbalances-show.component";
import {PurchasesShowComponent} from "./views/pro/purchases/purchases-show/purchases-show.component";
import {ReturninvoicesShowComponent} from "./views/pos/returninvoices/returninvoices-show/returninvoices-show.component";
import {RefundsShowComponent} from "./views/pro/refunds/refunds-show/refunds-show.component";
import {CostcentersShowComponent} from "./views/fin/costcenters/costcenters-show/costcenters-show.component";
import {ExchangeShowComponent} from "./views/pro/exchange/exchange-show/exchange-show.component";
import {InventoryShowComponent} from "./views/pro/inventory/inventory-show/inventory-show.component";
import {DepreciationShowComponent} from "./views/pro/depreciation/depreciation-show/depreciation-show.component";
import {SuppliersShowComponent} from "./views/setting/suppliers/suppliers-show/suppliers-show.component";
import {ItemsTransactionsListComponent} from "./views/pro/itemstransactions/itemstransactions-list/itemstransactions-list.component";
import {AccountbranchesShowComponent} from './views/fin/accountbranches/accountbranches-show/accountbranches-show.component';


export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
  align: "right",
  allowNegative: false,
  decimal: ".",
  precision: 2,
  prefix: "",
  suffix: "",
  thousands: ","
};

export function HttpLoaderFactory(httpClient: Http) {
    return new TranslateHttpLoader(httpClient, 'assets/i18n/', '.json');
}

@NgModule({
    imports: [
      BrowserModule,
      BrowserAnimationsModule,
      DropdownModule,
      AppRoutingModule,
      BsDropdownModule.forRoot(),
      TabsModule.forRoot(),
      FormsModule,
      ReactiveFormsModule,
      HttpModule,
      NgProgressModule,
      NgxPaginationModule,
      MultiSelectModule,
      ChartsModule,
      InputTextModule,
      DialogModule,
      NgbModule.forRoot(),
      ButtonModule,
      MessagesModule,
      MessageModule,
      PopoverModule,
      GrowlModule,
      BranchesShowComponent,
      DepartmentsShowComponent,
      ProcessesShowComponent,
      ClassificationsShowComponent,
      ArchiveShowComponent,
      BranchesSettingsShowComponent,
      MembersShowComponent,
      AccountbranchesShowComponent,
      CurrenciesShowComponent,
      RefundsShowComponent,
      TaxesShowComponent,
      AdditionalsShowComponent,
      ItemsShowComponent,
      OrganizationShowComponent,
      ItemsTransactionsListComponent,
      ItemsGroupsShowComponent,
      UsersShowComponent,
      InvoicesShowComponent,
      YearsShowComponent,
      OpeningbalancesShowComponent,
      Account_reportListComponent,
      JobsShowComponent,
      StoresShowComponent,
      CustomersShowComponent,
      CitiesShowComponent,
      JournalsShowComponent,
      ReturninvoicesShowComponent,
      CostcentersShowComponent,
      ExchangeShowComponent,
      InventoryShowComponent,
      DepreciationShowComponent,
      PermissionsShowComponent,
      EmployeesShowComponent,
      PurchasesShowComponent,
      SuppliersShowComponent,
      ItemlistsShowComponent,
      AccountsShowComponent,
      BanksShowComponent,
      RecieptVouchersShowComponent,
      ExpenseVouchersShowComponent,
      JournalsShowComponent,
      ConfirmDialogModule,
      ImageViewerModule,
      CurrencyMaskModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [Http]
            }
        })
    ],
    declarations: [
      AppComponent,
      AlertComponent,
      ...APP_CONTAINERS,
      ...APP_COMPONENTS,
      ...APP_DIRECTIVES,
      EqualValidator,
      AppLogComponent,
      AppTasksComponent,
      AppPdfComponent,
      AppArcComponent,
      UserProfileComponent,
      UserSettingsComponent,
      ParentShowComponent,
      UserPictureComponent,
      SaveTemplateComponent,
      RecordDataComponent,
      BranchesListComponent,
      DepartmentsListComponent,
      YearsListComponent,


    ],
    entryComponents: [
      AppLogComponent,
      AppTasksComponent,
      AppPdfComponent,
      UserProfileComponent,
      SaveTemplateComponent,
      RecordDataComponent,
      BranchesListComponent,
      DepartmentsListComponent,
      YearsListComponent,
      Account_reportListComponent,
      UserSettingsComponent,
      ParentShowComponent,
      UserPictureComponent,
      ListLayoutComponent,
      ItemBranchesComponent,
      BranchesShowComponent,
      DepartmentsShowComponent,
      ProcessesShowComponent,
      ClassificationsShowComponent,
      ArchiveShowComponent,
      BranchesSettingsShowComponent,
      MembersShowComponent,
      AccountbranchesShowComponent,
      CurrenciesShowComponent,
      ItemsGroupsShowComponent,
      SuppliersShowComponent,
      RefundsShowComponent,
      TaxesShowComponent,
      AdditionalsShowComponent,
      ExchangeShowComponent,
      InventoryShowComponent,
      DepreciationShowComponent,
      ItemsTransactionsListComponent,
      InvoicesShowComponent,
      YearsShowComponent,
      CostcentersShowComponent,
      UsersShowComponent,
      ItemsShowComponent,
      JournalsShowComponent,
      OrganizationShowComponent,
      ReturninvoicesShowComponent,
      EmployeesShowComponent,
      PurchasesShowComponent,
      JobsShowComponent,
      StoresShowComponent,
      CustomersShowComponent,
      AccountsShowComponent,
      CitiesShowComponent,
      PermissionsShowComponent,
      ItemlistsShowComponent,
      BanksShowComponent,
      RecieptVouchersShowComponent,
      ExpenseVouchersShowComponent,
      JournalsShowComponent,
      OpeningbalancesShowComponent,
      AppArcComponent,
    ],
    exports: [],
    providers: [customHttpProvider,
        AuthGuard,
        AlertService,
        AuthenticationService,
        UserService,
        ConfirmationService,
        ItemService,
        LogService,
        NgbActiveModal, { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig },
        {provide: BrowserXhr, useClass: NgProgressBrowserXhr},
        MessageService,
        {
            provide: LocationStrategy,
            useClass: HashLocationStrategy
        }],
    bootstrap: [AppComponent],
    schemas: [NO_ERRORS_SCHEMA]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts